import TemplateNovo from './TemplateNovo';

export default TemplateNovo;